import { MessageType } from "./messages";

export const getMessageTypes = async (
  callApi: (config: any) => Promise<any>
): Promise<MessageType[]> => {
  const response = await callApi({
    method: "GET",
    url: "/management/messages/types",
  });
  return response.data.data || [];
};
